export default {
    path: '/admin',
    name: 'admin',
    meta: {
        title: '管理员端'
    },
    component: resolve => require(['@/views/boss.vue'], resolve),
    redirect: '/admin/radarBed', 
    children: [
        {
            path: '/admin/radarBed',
            name: 'radarBed',
            meta: [{
                path: '/admin/radarBed',
                title: '雷达与床位配置',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/admin/radarBed.vue'], resolve),
        },
        {
            path: '/admin/addCutBed',
            name: 'addCutBed',
            meta: [{
                path: '',
                title: '雷达与床位配置',
                meta: [{
                    path: '/admin/addCutBed',
                    title: '增减床位'
                }],
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/admin/addCutBed.vue'], resolve),
        },
        {
            path: '/admin/nursingPerson',
            name: 'nursingPerson',
            meta: [{
                path: '/admin/nursingPerson',
                title: '护理人员配置',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/admin/nursingPerson.vue'], resolve),
        },
        {
            path: '/admin/radarMonitorDeploy',
            name: 'radarMonitorDeploy',
            meta: [{
                path: '/admin/radarMonitorDeploy',
                title: '搜索页',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/admin/radarMonitorDeploy.vue'], resolve),
        },
        {
            path: '/admin/radarPosition',
            name: 'searchPage',
            meta: [{
                path: '/admin/radarPosition',
                title: '监测仪位置管理',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/admin/radarPosition.vue'], resolve),
        },
        {
            path: '/admin/searchSnPos',
            name: 'searchSnPos',
            meta: [{
                path: '/admin/searchSnPos',
                title: '监测仪位置管理',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/admin/searchSnPos.vue'], resolve),
        },
        {
            path: '/admin/goBuild',
            name: 'goBuild',
            meta: [{
                path: '/admin/searchSnPos',
                title: '监测仪位置管理',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/admin/goBuild.vue'], resolve),
        },
        {
            path: '/admin/goFloor',
            name: 'goFloor',
            meta: [{
                path: '/admin/searchSnPos',
                title: '监测仪位置管理',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/admin/goFloor.vue'], resolve),
        },
    ],
}